// extracted by mini-css-extract-plugin
export default {"wrapper":"Companies_wrapper__BdfuP"};